import FavoriteComponentView from '../views/favorite.view.html';

class FavoriteController {
    constructor($scope, $http, toast) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.toast = toast;

        this.saving = false;
    }

    toggleFavorite() {
        this.$http.get((locale === 'en' ? '/en' : '') + `/user/api/favorite-products/favorite/${this.productId}`).then(response => {
            const data = response.data.data;

            if (!response.data.success) {
                return;
            }

            if (data.redirectUrl) {
                window.document.location.href = data.redirectUrl;
            }

            this.isFavorite = data.favorite;

            this.toast.create({
                message: data.message
            });
        });
    }
}

let favoriteComponent = {
    bindings: {
        productId: '<',
        isFavorite: '<'
    },
    template: FavoriteComponentView,
    controller: FavoriteController
};

export default favoriteComponent;
